import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesComponent } from './pages.component';
import { PagesRoutingModule } from './pages.routing';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { HeaderModule } from '../theme/header/header.module';
import { NotificationComponent } from './notification/notification.component';
import { StatsComponent } from './stats/stats.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { SettingsComponent } from './settings/settings.component';
import { ExModule } from './exercises/ex.module';
import { FavsModule } from './favs/favs.module';
import { ChipsModule } from '../theme/components/chips/chips.module';
import { GenericPageModule } from './generic-page/generic-page.module';
import { SupportModule } from './support/support.module';
import { FooterModule } from '../theme/footer/footer.module';
import { PasswordResetModule } from './password-reset/password-reset.module';
import { ContinueComponent } from './continue/continue.component';
import { DeleteComponent } from './delete/delete.component';
import { TeamSelectComponent } from './team-select/team-select.component';
import { ChallengeTutorialComponent } from './challenge-tutorial/challenge-tutorial.component';
import { RedirectModule } from './redirect/redirect.module';
import { ThemeModule } from '../theme/theme.module';

@NgModule({
  declarations: [
    PagesComponent,
    LoginComponent,
    NotificationComponent,
    StatsComponent,
    SignUpComponent,
    SettingsComponent,
    ContinueComponent,
    DeleteComponent,
    TeamSelectComponent,
    ChallengeTutorialComponent,
  ],
  imports: [
    CommonModule,
    PagesRoutingModule,
    SharedModule,
    ReactiveFormsModule,
    HeaderModule,
    FooterModule,
    ExModule,
    FavsModule,
    GenericPageModule,
    ChipsModule,
    SupportModule,
    PasswordResetModule,
    RedirectModule,
    ThemeModule,
  ],
})
export class PagesModule {}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/pages/pages.module.ts